var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.elevation)?_c('span',{staticClass:"is-nowrap",attrs:{"title":_vm.$gettext('elevation_max')}},[_c('fa-icon',{staticClass:"card-icon",attrs:{"icon":"sort-amount-up"}}),_vm._v("\n  "+_vm._s(_vm.elevation)+" m\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }